export default "__VITE_ASSET__BpN2JRRB__"